$.noConflict();
jQuery( document ).ready(function( $ ) {
  $("#owl-carousel").owlCarousel({
			nav: true, 		 
			slideSpeed : 100,
			margin:30,
			loop: false,
			pagination : false,
			items:4,
			scrollPerPage : true,
			slideBy: 1,
			responsive:{
				414:{items:1,margin:5},400:{items:1,margin:5},320:{items:1,margin:5},736:{items:2},768:{items:3},980:{items:3},1024:{items:3},1100:{items:4}
			}
		});
});

